define([
  /*eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/navigation-bar/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/navigation-bar/1.0.0/index.css',
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/riq-js/password-modal/1.0.0/index'
  /*eslint-enable */
], function directive(app, html, css, aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  app.registerDirective('navigationBar', function navigationBarDirective() {
    return {
      restrict: 'E',
      transclude: {
        center: '?centerTitle',
        right: '?rightTitle',
        back: '?backButtonLabel'
      },
      scope: {},
      template: html,
      controller: 'NavigationBarController',
      controllerAs: '$ctrl',
      bindToController: {
        previousCallback: '&?',
        previousState: '<?',
        previousStateParams: '<?',
        previousStateOptions: '<?',
        needsPasswordGate: '<?',
        hideBackButton: '<?',
        domScopeUuid: '@?'
      }
    };
  });

  app.registerController('NavigationBarController', [
    '$scope',
    '$element',
    '$transclude',
    '$state',
    'compileService',
    'passwordModalStateService',
    function navigationBarController(
      $scope,
      $element,
      $transclude,
      $state,
      compileService,
      passwordModalStateService
    ) {
      var _this = this;
      compileService.compile({css: css}, $scope, $element, $transclude);

      var HIDE_TOP_MARGIN_STATES = ['class_login_en'];
      _this.hideTopMargin =
        HIDE_TOP_MARGIN_STATES.indexOf($state.current.name) > -1;

      var goToPreviousState = function goToPreviousState() {
        if (_this.needsPasswordGate) {
          var state = storeService.getState();
          if (!state.passwordModal) {
            storeService.addState(passwordModalStateService);
          }
          storeService.commit([
            {
              stateAlias: 'passwordModal',
              mutationId: 'update',
              payload: {
                nextState: {
                  name: _this.previousState,
                  params: _this.previousStateParams
                }
              }
            },
            {
              stateAlias: 'riqModals',
              mutationId: 'show',
              payload: 'passwordModal'
            }
          ]);
        } else {
          $state.go(
            _this.previousState,
            _this.previousStateParams,
            _this.previousStateOptions
          );
        }
      };

      var goBack = function goBack() {
        if (_this.previousState) {
          goToPreviousState();
        } else if (typeof _this.previousCallback === 'function') {
          _this.previousCallback();
        }
      };

      _this.goBack = goBack;
    }
  ]);
});
